import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface Tab {
  key: string;
  label: string;
  count?: number;
  hidden?: boolean;
}

interface TabsProps {
  tabs: Tab[];
  activeKey: string;
  onChange: (key: string) => void;
  children: ReactNode;
}

export default function Tabs({ tabs, activeKey, onChange, children }: TabsProps) {
  const visibleTabs = tabs.filter((t) => !t.hidden);

  return (
    <div>
      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex gap-4 overflow-x-auto" aria-label="Tabs">
          {visibleTabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => onChange(tab.key)}
              className={clsx(
                'whitespace-nowrap border-b-2 py-2.5 px-1 text-sm font-medium transition-colors',
                activeKey === tab.key
                  ? 'border-blue-500 text-blue-600 dark:border-blue-400 dark:text-blue-400'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:border-gray-600 dark:hover:text-gray-300',
              )}
            >
              {tab.label}
              {tab.count !== undefined && (
                <span
                  className={clsx(
                    'ml-2 rounded-full px-2 py-0.5 text-xs',
                    activeKey === tab.key
                      ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/40 dark:text-blue-400'
                      : 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400',
                  )}
                >
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
      <div className="pt-4">{children}</div>
    </div>
  );
}
